import { styled } from '@mui/material';

/**
 * Used on all Authorised layouts to house the main content
 * It will fill the page on mobile, then remain centred on larger screens, with a maxWidth of 1200px
 */
const ContentWrapper = styled('div')(({ theme }) => ({
	pb: '0',
	display: 'flex',
	flexDirection: 'column',
	maxWidth: theme.breakpoints.values.lg,
	margin: '0 auto',
	[theme.breakpoints.up('md')]: {
		pb: '1rem',
	},
}));

export default ContentWrapper;
